var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[( _vm.getInfor === true && _vm.isMobile === false)?_c('PCProduct',{attrs:{"json":_vm.json}}):_vm._e(),( _vm.getInfor === true && _vm.isMobile === true)?_c('MobProduct',{attrs:{"json":_vm.json}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }